import { render } from "./productOrderPositionActions.vue?vue&type=template&id=89746478"
import script from "./productOrderPositionActions.vue?vue&type=script&lang=js"
export * from "./productOrderPositionActions.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__